import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ArrowIconMenuCollapse = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 26 26"
      width="26px"
      height="26px"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <g>
        <path
          d="M13 25.5C6.09644 25.5 0.5 19.9036 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13C25.5 19.9036 19.9036 25.5 13 25.5Z"
          fill="currentColor"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8 9.3999L8.20005 13.2399M8.20005 13.2399L11.8 17.0799M8.20005 13.2399H17.8"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_295_1578">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(0 0.805176)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(ArrowIconMenuCollapse);
